export class SentEnvelopeStatusCounter {
    pending: number;
    completed: number;
    expired: number;
    onApproval: number;
    toFill: number;
    deleted: number;
    reproved: number;
    rejected: number;
}
